<template>
  <!-- <v-menu
        offset-y
        close-on-click
        top
        :key="`${message.id}-menu`"
        max-width="200"
    > -->
  <!-- <template v-slot:activator="{ on, attrs }"> -->
  <v-flex xs8 :offset-xs4="message.fromMe === 1" class="mb-2" :key="message.id" max-width="500">
    <v-card :dark="message.fromMe === 1" class="shadow-2" :color="message.fromMe === 1 ? 'secondary' : ''">
      <v-card-text class="pb-1">
        <v-alert v-if="message.isDeleted === 1" dense colored-border type="info" :key="message.id">
          Mensaje eliminado.
        </v-alert>

        <v-alert
          v-if="message.answered_message != null"
          elevation="0"
          text
          color="info"
          class="caption py-1 shadow-1"
          colored-border
          border="left"
          style="border-radius: 8px !important;"
        >
          <div>
            <strong :class="message.fromMe == 1 ? 'cyan--text text--lighten-2' : 'info--text'">
              {{ message.answered_message.fromMe == 1 ? "Tú" : NameClient }}
            </strong>
          </div>
          <pre class="replyMessage text-left mb-0" v-if="message.answered_message.mediaType == 'chat'">
                        {{ message.answered_message.body }}
                    </pre
          >

          <v-img
            v-else
            :src="message.answered_message.mediaUrl"
            :lazy-src="message.answered_message.mediaUrl"
            class="grey lighten-2"
            max-width="50"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-alert>

        <pre
          v-if="message.isDeleted !== 1"
          :class="message.fromMe === 1 ? 'white--text' : 'text--primary'"
          class="text--body-2 mb-1"
        >
                    {{ message.body }}
                </pre
        >
        <v-btn v-if="messageUrl" :href="messageUrl" target="_blank" outlined block small class="mt-2">
          Abrir enlace
        </v-btn>

        <span class="ml-n2" v-if="message.fromMe === 1">
          <!-- Estado de envío (reloj) -->
          <v-icon v-if="message.ack === 0" small color="grey lighten-1">
            mdi-clock-outline
          </v-icon>

          <!-- Estado de error -->
          <v-icon v-else-if="message.ack === -1" small color="error">
            mdi-alert-circle
          </v-icon>

          <!-- Estados de envío exitoso -->
          <template v-else-if="message.ack >= 1">
            <v-icon small :color="message.ack === 3 ? 'teal lighten-2' : 'grey lighten-1'">
              mdi-check
            </v-icon>
            <v-icon
              small
              :color="message.ack === 3 ? 'teal lighten-2' : 'grey lighten-1'"
              class="ml-n3"
              v-if="message.ack >= 2"
            >
              mdi-check
            </v-icon>
          </template>
        </span>

        <small>{{ message.created_at | getHour12Format }}</small>
      </v-card-text>

      <v-avatar v-if="message.reaction" color="blue-grey darken-4" size="26" class="ml-1 mb-n3">
        {{ message.reaction }}
      </v-avatar>
    </v-card>
  </v-flex>
  <!-- </template> -->

  <!-- <v-list dense>
            <v-list-item @click="replyMessage(message.id)">
            <v-list-item-title>Responder</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="deleteMessage(message.id)">
            <v-list-item-title>Eliminar</v-list-item-title>
            </v-list-item>
        </v-list> -->
  <!-- </v-menu> -->
</template>

<script>
import moment from "moment";

export default {
  props: {
    message: {
      type: Object,
    },
    NameClient: {
      type: String,
    },
  },

  filters: {
    getHour12Format(date) {
      const hour = moment(date).format("LT");
      return hour;
    },
  },

  computed: {
    /**
     * Devuelve la URL encontrada en el mensaje.
     * @returns {string|null}
     */
    messageUrl() {
      if (this.message.isDeleted === 1) return null;
      return this.extractUrl(this.message.body);
    },
  },

  methods: {
    /**
     * Extrae el primer enlace válido encontrado en un texto.
     * @param {string} text - Texto a analizar.
     * @returns {string|null} URL encontrada o null si no existe.
     */
    extractUrl(text) {
      if (!text) return null;

      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const match = text.match(urlRegex);

      return match ? match[0] : null;
    },
  },
};
</script>

<style>
pre {
  white-space: pre-line;
  font-family: Arial, Helvetica, sans-serif !important;
}

.replyMessage {
  display: -webkit-box; /* Utiliza un contenedor flexible */
  -webkit-box-orient: vertical; /* Define la orientación en vertical */
  -webkit-line-clamp: 3; /* Limita a 2 líneas */
  overflow: hidden; /* Oculta el desbordamiento */
  text-overflow: ellipsis; /* Agrega puntos suspensivos */
  white-space: normal; /* Permite el salto de línea */
}
</style>
